import { DRYWALL_AND_PAINT_PHASE_TYPE_TO_PRIORITY } from 'utils/phaseUtils';
import { PhaseTypeEnum } from '@vatos-pas/common';
import { WorkflowConfig, ColumnDef } from './types';

const DAP_COLUMNS: ColumnDef[] = [
  { type: 'supervisor', label: 'Supervisors' },
  { type: 'text', source: 'jobLot', label: 'Lot' },
  { type: 'text', source: 'jobBlock', label: 'Block' },
  {
    type: 'text',
    source: 'poId',
    label: 'PO Id',
    sortable: false,
    adminOnly: true,
    hideOnWarranty: true,
  },
  { type: 'text', source: 'builderName', label: 'Builder' },
  { type: 'text', source: 'subdivisionName', label: 'Subdivision' },
  { type: 'dash-field', source: 'payableBoardsTotal', label: 'Payable Boards' },
  {
    type: 'dash-field',
    source: 'payableBoardsReceiptTotal',
    label: 'Supervisor Count',
  },
  { type: 'dash-field', source: 'totalSquareFootage', label: 'Payable Sq\nFt' },
  { type: 'date', source: 'poSignedAt', label: 'Project Start Date' },
  { type: 'text', source: 'currentPhaseName', label: 'Current Phase' },
  {
    type: 'number',
    source: 'currentPhaseDaysCount',
    label: 'Current Phase Days',
  },
  { type: 'number', source: 'jobDaysCount', label: 'Job Days' },
  { type: 'phase-contractor-current', label: 'Phase Contractor' },
  {
    type: 'editable-date',
    label: 'Prime Date',
    priority: DRYWALL_AND_PAINT_PHASE_TYPE_TO_PRIORITY[PhaseTypeEnum.Prime],
    contractorField: 'primePhaseContractorName',
    suggestedField: 'primePhaseSuggestedContractorName',
    dateSource: 'primePhaseDateStart',
    jobPhaseIdField: 'primeJobPhaseId',
    customDateField: 'customPrimeDateStart',
    historyTitle: 'Prime Date Change History',
  },
  { type: 'submit-button', label: '', hideOnWarranty: true },
];

export const DRYWALL_AND_PAINT_CONFIG: WorkflowConfig = {
  phaseStructureType: 'DrywallAndPaint',

  list: {
    columns: DAP_COLUMNS,
    editableDateColumns: [
      { field: 'customPrimeDateStart', label: 'Prime Date' },
    ],
    bulkActionsEnabled: false,
    statusColumnEnabled: false,
    preRockColumnEnabled: false,
    defaultSort: { field: 'poSignedAt', order: 'ASC' },
    pagination: { perPage: 50, rowsPerPageOptions: [5, 10, 25, 50] },
  },

  timeline: {
    sprayReadinessEnabled: false,
    bumpoutTimesheetDesktopBehaviors: false,
    goBackWarnings: {},
  },

  filters: {
    phaseStructureType: 'DrywallAndPaint',
  },

  edit: {
    backUrl: '/job-master-sheet-v2',
    warrantyUrlSegment: 'job-warranty-sheet-v2',
    statusBarThreshold: 'gte200',
    mobileBreakpoint: '600px',
    boardsMountStrategy: 'conditional',
    tabBarColor: '#026584',
  },

  email: {
    managementType: 'single-supervisor',
  },

  tracking: {
    mixpanelEnabled: false,
  },
};
